import React from 'react';
import { Box } from '@mui/material';
import { MEDIAS } from '../../assets/medias';

const VideoBlock = () => {
    return (
        <Box
            sx={{
                width: { xs: '90%', sm: '50%' }, // Sur mobile, la vidéo occupe 100% de la largeur
                height: { xs: '100%', sm: '100%' }, // Hauteur fixe sur mobile et 100% sur grand écran
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 2,
                position: 'relative',
            }}
        >
            {/* <Box
    sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '15px',
        overflow: 'hidden',   // Pour que le border-radius affecte aussi le contenu interne
    }}
> */}
            <video
                src={MEDIAS.auth_video}
                autoPlay
                loop
                muted
                style={{

                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '15px', // Appliquer un border-radius directement à la vidéo
                }}
            />
            {/* </Box> */}
        </Box>
    )
}

export default VideoBlock;